<template>
  <div>
    <v-container>
      <div>
        <date-filter
          @changeDate="getData"
          :defaultFilter="'today'"
          v-model="selectedDate"
        ></date-filter>
      </div>
      <div class="mt-3">
        <div class="title mb-3">จำนวนการลงทะเบียนหาช่าง</div>
        <v-card style="width: 300px" class="mx-auto">
          <div class="pa-3 text-xs-center">
            <v-progress-circular
              style="margin-top: 29.2px; margin-bottom: 17.52px; height: 48px"
              v-if="loading"
              indeterminate
              color="primary"
            ></v-progress-circular>
            <h3 v-else>{{ total | numberFormat }}</h3>
          </div>
        </v-card>
        <v-pagination
          class="mt-2"
          :total-visible="15"
          v-model="pageNumber"
          @input="changePage"
          :length="pagelength"
        ></v-pagination>
        <v-data-table
          v-bind:pagination.sync="pagination"
          :headers="headers"
          :items="items"
          class="elevation-1"
          hide-actions
          :loading="loading"
        >
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-center">
                <v-avatar>
                  <v-img
                    v-if="/(\.pdf$)/.test(props.item.profile_pic)"
                    src="/static/img/pdf-image-placeholder.94190da.png"
                  ></v-img>
                  <v-img v-else :src="props.item.profile_pic"></v-img>
                </v-avatar>
              </td>
              <td class="text-xs-center">
                <div style="white-space: nowrap">
                  {{ props.item.first_name }} {{ props.item.last_name }}
                </div>
              </td>
              <td class="text-xs-center">
                <div>{{ props.item.work_type ? props.item.work_type : '-' }}</div>
              </td>
              <td class="text-xs-center">
                <div>{{ props.item.phoneno ? props.item.phoneno : '-' }}</div>
              </td>
              <td class="text-xs-center">
                <div>{{ props.item.email ? props.item.email : '-' }}</div>
              </td>
              <td class="text-xs-center">
                <div>
                  {{
                    `${props.item.address1} เขต${props.item.sub_district} แขวง${props.item.district} จังหวัด${props.item.province} เลขไปรษณีย์${props.item.zip_code} `
                  }}
                </div>
              </td>
              <td class="text-xs-center">
                <div>{{ props.item.work_area ? props.item.work_area : '-' }}</div>
              </td>
              <td class="text-xs-center">
                <div>
                  <v-btn
                    :disabled="!props.item.work_area_images || !props.item.work_area_images.length"
                    @click="showImageWork(props.item.work_area_images)"
                  >
                    <em class="fas fa-image mr-2" /> ดูรูปหน้างาน ({{
                      props.item.work_area_images.length
                    }})
                  </v-btn>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-container>
    <div v-if="showImage">
      <Tinybox v-model="index" :images="currentImages" loop />
    </div>
  </div>
</template>

<script>
import api from '@/api'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import { mapGetters } from 'vuex'
import moment from 'moment'
import Tinybox from 'vue-tinybox'
export default {
  components: {
    DateFilter,
    Tinybox
  },
  data() {
    return {
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      currentImages: [],
      showImage: false,
      index: null,
      loading: false,
      selectedDate: {
        start: moment().format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      items: [],
      pagination: { sortBy: 'none', descending: true, rowsPerPage: 25 },
      data: [],
      headers: [
        { text: '', value: 'profile_pic', sortable: false },
        { text: 'ชื่อ', value: 'first_name', align: 'center', width: '1%' },
        { text: 'ประเภทงาน', value: 'work_type', align: 'center', width: '1%' },
        { text: 'เบอร์โทรศัพท์', value: 'phoneno', align: 'center', width: '1%' },
        { text: 'อีเมลลูกค้า', value: 'email', align: 'center', width: '1%' },
        { text: 'ที่อยู่ลูกค้า', value: 'address1', align: 'center', width: '1%' },
        { text: 'ขนาดพื้นที่ทำงาน', value: 'work_area', align: 'center', width: '1%' },
        { text: 'รูปหน้างาน', value: 'work_area_images', align: 'center', width: '1%' }
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / 10)
      } else {
        return 1
      }
    }
  },
  async mounted() {
    await this.getData()
  },
  methods: {
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getData()
      }
    },
    showImageWork(images) {
      this.currentImages = images
      this.showImage = true
      this.index = 0
    },
    getData() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid,
          datefrom: moment(this.selectedDate.start).format('YYYY-MM-DD'), // YYYY-MM-DD
          dateto: moment(this.selectedDate.end).format('YYYY-MM-DD'), // YYYY-MM-DD
          limit: this.limit,
          offset: this.offset
        }
        this.loading = true
        api.searchpainterdashboard(data, (err, response) => {
          this.loading = false
          this.data = response.data
          this.total = response.total
          try {
            this.items = this.data.map((el) => {
              return JSON.parse(el.productdetail)
            })
          } catch (error) {
            this.items = []
          }
          resolve()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toa/Painter/searchpainterdashboard.vue